import { useCallback } from 'react'
import { ZOOM_FACTOR, ZOOM_MAX, ZOOM_MIN } from './attachmentGalleryConstants.js'

export function useAttachmentImageGalleryActions({
  current,
  previewSrc,
  safeLen,
  setActiveIndex,
  setZoom,
}) {
  const zoomOut = useCallback(() => setZoom((z) => Math.max(ZOOM_MIN, z / ZOOM_FACTOR)), [setZoom])
  const zoomIn = useCallback(() => setZoom((z) => Math.min(ZOOM_MAX, z * ZOOM_FACTOR)), [setZoom])

  const handleDownload = useCallback(() => {
    if (!current?.file) return
    const url = previewSrc || URL.createObjectURL(current.file)
    const a = document.createElement('a')
    a.href = url
    a.download = current.file.name
    document.body.appendChild(a)
    a.click()
    a.remove()
    if (!previewSrc) window.URL.revokeObjectURL(url)
  }, [current, previewSrc])

  const goPrev = useCallback(() => {
    setZoom(1)
    setActiveIndex((i) => (i > 0 ? i - 1 : i))
  }, [setActiveIndex, setZoom])

  const goNext = useCallback(() => {
    setZoom(1)
    setActiveIndex((i) => (i < safeLen - 1 ? i + 1 : i))
  }, [safeLen, setActiveIndex, setZoom])

  const handleScrimClickCapture = useCallback((e, onClose) => {
    const target = e.target
    if (!(target instanceof Element)) return
    if (target.closest('header') || target.closest('footer') || target.closest('button')) return
    if (target.tagName === 'IMG' && !target.closest('footer')) return
    onClose(e)
  }, [])

  return { zoomOut, zoomIn, handleDownload, goPrev, goNext, handleScrimClickCapture }
}
